import { useInfiniteQuery } from '@tanstack/react-query';
import { Interval } from 'luxon';

import { getRejectedPurchasesInsightForEntity, RejectedPurchasesSortable } from 'apis/merchant-gateway/insights';
import { EntityType } from 'common/types';

import { RejectedPurchasesTableColumnIDs } from '../components/tables/rejections/types';
import { SortOrder } from '../components/tables/types';

type RejectedPurchasesInsightParams = {
  entityType: EntityType;
  entityId: string;
  interval: Interval;
  sortBy?: RejectedPurchasesTableColumnIDs;
  sortOrder?: SortOrder;
};

const NUM_ITEMS_PER_PAGE = 20;

export const transformToAPISortableField = (
  value?: RejectedPurchasesTableColumnIDs,
): RejectedPurchasesSortable | undefined => {
  return value === RejectedPurchasesTableColumnIDs.ORDER_TIME ? 'TIME_RECEIVED' : undefined;
};

const useRejectedPurchasesInsights = ({
  entityId,
  entityType,
  interval,
  sortBy,
  sortOrder,
}: RejectedPurchasesInsightParams) => {
  const sortableField = transformToAPISortableField(sortBy);
  return useInfiniteQuery(
    ['rejections-insights', entityId, entityType, interval, sortableField, sortOrder],
    ({ pageParam: cursor }) =>
      getRejectedPurchasesInsightForEntity({
        entityType,
        entityId,
        interval,
        limit: NUM_ITEMS_PER_PAGE,
        cursor,
        sortBy: sortableField,
        sortOrder,
      }),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      getNextPageParam: lastPage => lastPage.pagination?.next,
      getPreviousPageParam: firstPage => firstPage.pagination?.previous,
      keepPreviousData: true,
    },
  );
};

export default useRejectedPurchasesInsights;
